/** @format */
import { createTheme, colors } from '@material-ui/core'

export default createTheme({
  palette: {
    primary: {
      main: colors.blue[800],
    },
    secondary: {
      main: colors.grey[800],
    },
    flexhome: {
      main: '#0054a6',
    },
  },
  // shape: {
  //   borderRadius: '10px'
  // },
  typography: {
    fontFamily: ['"Montserrat"', 'sans-serif'].join(','),
  },
  breakpoints: {
    values: {
      xs: 400,
      sm: 600,
      768: 768,
      960: 960,
      md: 960,
      1024: 1024,
      1100: 1100,
      1280: 1280,
      lg: 1280,
      1366: 1366,
      1400: 1400,
      1600: 1600,
      xl: 1920,
    },
  },
})
